import routerOptions0 from "/Users/niko/Developer/FunAcademy/fun-academy-campus/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@22.5.4_encoding@0.1.13_eslint@9.10.0_jiti@1.21._ydmfjhcxqqhxl6kkxqpdbfxksa/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}